import React from 'react';

type SidebarSkin = 'light' | 'dark' | 'neutral'; // FIXME: import definition

type SidebarParent = 'sidebar' | 'subMenu' | 'inContextMenu';

type SidebarMenuExpandTrigger = 'click' | 'select';

export type SidebarNextContextValue = {
  /** Sidebar skin */
  skin: SidebarSkin;

  /** Indicates whether the sidebar is minimized */
  minimized: boolean;

  /** Indicates whether the sidebar is hidden */
  hidden: boolean;

  /** Indicates whether the sidebar or its subtree is non-interactive */
  inert: boolean;

  /**
   * Nesting level/depth of the sidebar subtree. Sub-menus and items use this
   * to determine their styles and behaviors.
   */
  level: number;

  /**
   * Parent/owner of the sidebar subtree. Used by sub-menus and items to
   * determine their styles and behaviors.
   */
  parent: SidebarParent;

  /** `RefObject` of sidebar content scroll area. Used to position popovers */
  scrollAreaRef: React.RefObject<HTMLElement>;

  /** Current selected item path */
  selectedPath: string[];

  /** Indicates whether the first level menu has a prefix */
  isFirstLevelWithPrefix?: boolean;

  /** Trigger of latest menu expanded state change */
  expandTrigger: SidebarMenuExpandTrigger;

  /** Indicates whether the sidebar is in legacy styling mode */
  legacy: boolean;

  isExpanded: (itemKey: string) => boolean;

  setExpanded: (itemKey: string, isExpanded: boolean) => void;

  /** Closes currently open quick nav popover within the ancestor */
  closeQuickNav?: () => void;
};

const defaultContextValue: SidebarNextContextValue = {
  skin: 'dark',
  minimized: false,
  hidden: false,
  inert: false,
  level: 1,
  parent: 'sidebar',
  isFirstLevelWithPrefix: false,
  scrollAreaRef: { current: null },
  selectedPath: [],
  expandTrigger: 'select',
  legacy: false,
  isExpanded: () => false,
  setExpanded: () => {},
};

export const SidebarNextContext =
  React.createContext<SidebarNextContextValue>(defaultContextValue);
